import { defineComponent as _defineComponent } from 'vue'
import {Vue, Component, Prop} from 'vue-property-decorator';
import BaseBadge, {BaseBadgeClass} from '@/components/badges/base/BaseBadge.vue';
import {BankDictionaryElement} from '@/modules/banks/models/BankDictionaryElement';


export default /*#__PURE__*/_defineComponent({
  __name: 'InstitutionBadge',
  props: {
    institution: null,
    loading: { type: Boolean },
    customSize: null
  },
  setup(__props: any) {

const props = __props as {
  institution: BankDictionaryElement | undefined,
  loading?: boolean,
  customSize?: number,
}



return { __sfc: true,props, BaseBadge }
}

})